module.exports = __webpack_public_path__ + "img/swiper_2.82aea3ff.png";